import { render, staticRenderFns } from "./OutpatientChargeList.vue?vue&type=template&id=0c7652d0&scoped=true"
import script from "./OutpatientChargeList.vue?vue&type=script&lang=js"
export * from "./OutpatientChargeList.vue?vue&type=script&lang=js"
import style0 from "./OutpatientChargeList.vue?vue&type=style&index=0&id=0c7652d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7652d0",
  null
  
)

export default component.exports